<template>
    <v-container fluid>
        <v-layout justify-center>
            <v-flex xs12 sm10 md10>
              <DataTableMain :datatable="table" :on-success="successAction" :itemsAction="tableAction"/>
            </v-flex>
        </v-layout>
        <PermisosDialog
        :model="permiso"
        v-if="get_dialogMain.dialog && (get_dialogMain.type == 'create' || get_dialogMain.type == 'update')" />
</v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DataTableMain from '@/components/tables/DataTableMainLocal'
import PermisosDialog from '@/components/dialog/catalogo/PermisosDialog'

export default {
  data: () => ({
    table: {
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData', code: 'libre', hidden: '' }
        ],
        titles: [
          { text: 'Nombre', value: 'nombre', class: 'black--text' },
          { text: 'Slug', value: 'slug', class: 'black--text' },
          { text: 'Descripcion', value: 'descripcion', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: []
      },
      footer: {
        paging: true
      }
    },
    permiso: {}
  }),
  components: {
    DataTableMain,
    PermisosDialog
  },
  mounted () {
    this.getUrl('empresa.permisos-list')
  },
  methods: {
    successAction (item) {
      this[item.action](item)
    },
    refreshData (item) {
      this.table.header.loading = true
      this.getUrl('empresa.permisos-list')
    },
    newData (item) {
      this.SHOW_DIALOG_MAIN({ type: 'create', with: 500, title: 'Nuevo Permiso' })
    },
    tableAction (item) {
      this[item.action](item)
    },
    ...mapActions(['getUrlServices', 'postServiceListAction']),
    getUrl (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.postServiceListAction({ url: router, data: {} })
      } else {
        this.getUrlServices()
      }
    },
    ...mapMutations(['SHOW_DIALOG_MAIN', 'CLEAR_OBJECTS'])
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_urls', 'get_objects'])
  },
  watch: {
    get_urls () {
      this.getUrl('empresa.permisos-list')
    },
    get_objects (vals) {
      if (vals) {
        this.table.header.loading = false
        this.table.body.data = vals
      }
    }
  },
  beforeDestroy () {
    this.CLEAR_OBJECTS()
  }

}
</script>

<style>

</style>
